export default __webpack_public_path__ + "static/media/icon_google_pay.c552fc50.png";